<template>
  <div class="friendRank">
    <div class="friends-text"></div>
    <div class="friends-list" v-if="hasFriendHelped">
      <div class="friends-item" v-for="(item, index) in help_users" :key="index">
        <img class="friends-img" :src="item.headimgurl">
        <div class="friends-name">{{item.nickname}}</div>
        <div class="friends-money">
          帮拆
          <span class="friends-money-number">{{item.price}}</span> 元
        </div>
      </div>
    </div>
    <div class="friends-empty" v-else>这里空空如也</div>
  </div>
</template>

<script>
export default {
  name: 'friendRank',
  props: ['hasFriendHelped', 'help_users'],
  computed: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index.scss';
.friends {
  &-text {
    @include set-image('../assets/images/text-friends.png');
    @include set-size(406, 32);
    @include set-lt(172, 0);
  }
  &-empty {
    @include set-property(font-size, 25);
    @include set-lt(304, 32);
    color: #f19e3c;
  }
  &-list {
    @include set-lt(0, 46);
    width: 100vw;
    display: flex;
    justify-content: space-around;
  }
  &-img {
    margin: 0 auto;
    border-radius: 50%;
    @include set-size(74, 74);
  }
  &-name {
    color: #fddb9b;
    max-width: 7em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-money {
    color: #fddb9b;
    &-number {
      @include set-property(font-size, 22);
      color: #ffffff;
    }
  }
  &-item {
    @include set-property(font-size, 20);
    width: 7em;
    text-align: center;
  }
}
@media (min-aspect-ratio: 750/1182) {
  .friends {
    &-text {
      @include set-size(406, 36);
      @include set-lt(170, 12);
      z-index: 10;
    }
    &-empty {
      @include set-lt(302, 46);
      z-index: 10;
    }
    &-list {
      @include set-lt(0, 56);
      width: 100vw;
      display: flex;
      justify-content: space-around;
      z-index: 10;
    }
  }
}
</style>